/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- OVERVIEW : STYLES --------------- ++++++++++ */
export default theme => ({
    overview: {
        '& .cardwrapper': {
            marginBottom: pxToEm(16)
        }
	}
});
